import CompanyQuoteInfoTitle from './CompanyQuoteInfoTitle'
export { CompanyQuoteInfoTitle }
export default CompanyQuoteInfoTitle
